<template>
  <div>
    <ContenedorCollapsable
      idCollapsable="duracion"
      tituloColapsable="¿Cuántos terminan la carrera y cuánto tiempo se demoran?"
    >
      <div class="kpis col-12 col-md-10 mx-auto mt-2 border-bottom-azul">
        <h3 class="subtt text-azul-medio w-100 text-center mt-3 mb-2">
          número de titulados
        </h3>

        <div class="d-md-flex">
          <div class="col-md-5 sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">{{ carrera1.carreraGenerica }}</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">{{ año1 }}:</dt>
                  <dd class="cont col">
                    {{
                      formatoNumerico(carrera1.totalTituladosAntePenultimoAnio)
                    }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">{{ año2 }}:</dt>
                  <dd class="cont col">
                    {{ formatoNumerico(carrera1.totalTituladosPenultimoAnio) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              src="@/assets/img/iconos/comparador-5.svg"
              alt="birrete"
            />
          </div>
          <hr class="mt-0 d-block d-md-none" />

          <div class="col-md-5 sel2">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">
                {{ carrera2.carreraGenerica }}
              </h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">{{ año1 }}:</dt>
                  <dd class="cont col">
                    {{
                      formatoNumerico(carrera2.totalTituladosAntePenultimoAnio)
                    }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">{{ año2 }}:</dt>
                  <dd class="cont col">
                    {{ formatoNumerico(carrera2.totalTituladosPenultimoAnio) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="kpis col-12 col-md-10 mx-auto mt-2 mb-3">
        <h3 class="subtt text-azul-medio w-100 text-center mt-3 mb-2">
          duración de carrera
        </h3>

        <div class="d-md-flex">
          <div class="col-md-5 sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">{{ carrera1.carreraGenerica }}</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">Duración<br />Formal:</dt>
                  <dd class="cont col">
                    {{ carrera1.duracionFormalPromedio }} semestres
                  </dd>
                </li>
                <li>
                  <dt class="label col">Duración<br />Real Promedio*:</dt>
                  <dd :class="reducirPadding(carrera1.duracionRealPromedio)">
                    {{ textoDuracionCarrera(carrera1.duracionRealPromedio) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              src="@/assets/img/iconos/comparador-6.svg"
              alt="calendario"
            />
          </div>
          <hr class="mt-0 d-block d-md-none" />

          <div class="col-md-5 sel2">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">
                {{ carrera2.carreraGenerica }}
              </h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">Duración<br />Formal:</dt>
                  <dd class="cont col">
                    {{ carrera2.duracionFormalPromedio }} semestres
                  </dd>
                </li>
                <li>
                  <dt class="label col">Duración<br />Real Promedio*:</dt>
                  <dd :class="reducirPadding(carrera2.duracionRealPromedio)">
                    {{ textoDuracionCarrera(carrera2.duracionRealPromedio) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-10 mx-auto mt-2 mb-3">
          <p class="small">
            <strong>*:</strong> La duración real promedio corresponde al tiempo
            promedio en semestres que se demoran en terminar la carrera.
          </p>
        </div>
      </div>
    </ContenedorCollapsable>
  </div>
</template>

<script>
import ContenedorCollapsable from "@/components/comparadorITP/ContenedorCollapsable";
import FormatoMonetario from "@/utils/FormatoMonetario.js";

export default {
  name: "TiempoDuracionCollapse",
  components: {
    ContenedorCollapsable
  },
  data() {
    return {
      año1: PLATAFORMA_TP.ANIO.COMPARADOR.TITULADOS_ANIO_1,
      año2: PLATAFORMA_TP.ANIO.COMPARADOR.TITULADOS_ANIO_2
    };
  },
  props: {
    carrera1: { type: Object },
    carrera2: { type: Object }
  },
  methods: {
    formatoNumerico(value) {
      return FormatoMonetario.getFormatoNumerico(value);
    },
    textoDuracionCarrera(valor) {
      return valor != 0 ? `${valor} semestres` : "SIN INFORMACIÓN DISPONIBLE";
    },
    reducirPadding(valor) {
      return valor != 0 ? "cont col" : "cont";
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/TiempoDuracionCollapse.vue